import initialState from "./initialState"
import { SET_INITIAL_PAGE, SET_RESPONSIVE_DATA } from '../constants/UIActionType'
import { CLEAR_STORE_DATA, CLEAR_LOGIN_DATA, RECOVER_FROM_ERROR_STATE } from "../constants/ClearStoreActionType";

export default function UIReducer(state = initialState.ui, action) {
    let newState = JSON.parse(JSON.stringify(state));
    let clean = JSON.parse(JSON.stringify(initialState.ui));

    switch (action.type) {
        case SET_INITIAL_PAGE:
            newState.initialpage = action.value
            return newState

        case SET_RESPONSIVE_DATA:
            newState.responsive = action.value
            return newState

        case CLEAR_STORE_DATA:
            newState = { ...clean }
            return newState

        case CLEAR_LOGIN_DATA:
            return state

        case RECOVER_FROM_ERROR_STATE:
            newState = { ...clean }
            return newState

        default: return state;
    }
}
